import { useState } from 'react';
import Button from '../../designSystem/Button/Button';
import { RegisterStepButtonProps } from './RegisterStepButton.types';
import { ButtonColor, ButtonSize } from '../../designSystem/Button/Button.types';
import Modal from '../Modal/Modal';
import { signOut } from '../../../store/authentication/authenticationActions/authenticationActions';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { ModalSizes } from '../Modal/Modal.types';
import { useNavigate } from 'react-router-dom';

export default ({ isCompany, ...props }: RegisterStepButtonProps) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        onClick={(e) => {
          e.preventDefault();
          setModalOpen(true);
        }}
        size={ButtonSize.Large}
        color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}
        style={{
          marginBottom: 'var(--spacing-s)',
        }}
        {...props}>
        Me déconnecter et terminer plus tard
      </Button>
      <Modal
        isOpen={isModalOpen}
        setOpen={setModalOpen}
        size={ModalSizes.Small}
        closeOnClickOutside>
        <p>
          Si vous ne terminez pas votre inscription avant 14 jours, votre compte sera supprimé et
          vous devrez recommencer{' '}
        </p>
        <Button
          onClick={(e) => {
            e.preventDefault();
            signOut(queryClient)(dispatch);
            navigate('/');
          }}
          size={ButtonSize.Large}
          color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}>
          Revenir plus tard
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            setModalOpen(false);
          }}
          size={ButtonSize.Large}
          color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}>
          Finaliser mon inscription
        </Button>
      </Modal>
    </>
  );
};
